"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _marketing = require("@/api/marketing");
var _product = require("@/api/product");
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
// +----------------------------------------------------------------------
// | CRMEB [ CRMEB赋能开发者，助力企业发展 ]
// +----------------------------------------------------------------------
// | Copyright (c) 2016~2025 https://www.crmeb.com All rights reserved.
// +----------------------------------------------------------------------
// | Licensed CRMEB并不是自由软件，未经许可不能去掉CRMEB相关版权
// +----------------------------------------------------------------------
// | Author: CRMEB Team <admin@crmeb.com>
// +----------------------------------------------------------------------
var _default2 = exports.default = {
  name: 'CouponList',
  props: {
    handle: {
      type: String,
      default: ''
    },
    couponData: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    keyNum: {
      type: Number,
      default: 0
    },
    userIds: {
      type: String,
      default: ''
    },
    userType: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      listLoading: true,
      tableData: {
        data: [],
        total: 0
      },
      tableFrom: {
        keywords: '',
        type: ''
      },
      multipleSelection: [],
      multipleSelectionAll: [],
      idKey: 'id',
      nextPageFlag: false,
      attr: []
    };
  },
  watch: {
    keyNum: {
      deep: true,
      handler: function handler(val) {
        this.getList();
      }
    }
  },
  mounted: function mounted() {
    var _this = this;
    this.tableFrom.page = 1;
    this.getList();
    if (!this.couponData) return;
    this.couponData.forEach(function (row) {
      _this.$refs.table.toggleRowSelection(row);
    });
  },
  methods: {
    dialogcloseFun: function dialogcloseFun() {
      this.$emit('dialogclose', null);
    },
    close: function close() {
      this.multipleSelection = [];
    },
    handleSelectionChange: function handleSelectionChange(val) {
      var _this2 = this;
      this.multipleSelection = val;
      setTimeout(function () {
        _this2.$selfUtil.changePageCoreRecordData(_this2.multipleSelectionAll, _this2.multipleSelection, _this2.tableData.data, function (e) {
          _this2.multipleSelectionAll = e;
        });
      }, 50);
    },
    // 设置选中的方法
    setSelectRow: function setSelectRow() {
      if (!this.multipleSelectionAll || this.multipleSelectionAll.length <= 0) {
        return;
      }
      // 标识当前行的唯一键的名称
      var idKey = this.idKey;
      var selectAllIds = [];
      this.multipleSelectionAll.forEach(function (row) {
        selectAllIds.push(row[idKey]);
      });
      this.$refs.table.clearSelection();
      for (var i = 0; i < this.tableData.data.length; i++) {
        if (selectAllIds.indexOf(this.tableData.data[i][idKey]) >= 0) {
          // 设置选中，记住table组件需要使用ref="table"
          this.$refs.table.toggleRowSelection(this.tableData.data[i], true);
        }
      }
    },
    ok: function ok() {
      if (this.multipleSelection.length > 0) {
        this.$emit('getCouponId', this.multipleSelectionAll);
        this.close();
      } else {
        this.$message.warning('请先选择优惠劵');
      }
    },
    // 列表
    getList: function getList(num) {
      var _this3 = this;
      this.listLoading = true;
      this.tableFrom.page = num ? num : this.tableFrom.page;
      this.userType ? this.tableFrom.type = 1 : this.tableFrom.type = 3;
      (0, _product.productCouponListApi)(this.tableFrom).then(function (res) {
        _this3.tableData.data = res;
        _this3.tableData.total = res;
        _this3.listLoading = false;
        _this3.$nextTick(function () {
          this.setSelectRow(); // 调用跨页选中方法
        });
      }).catch(function (res) {
        _this3.listLoading = false;
      });
    },
    pageChange: function pageChange(page) {
      var _this4 = this;
      this.$selfUtil.changePageCoreRecordData(this.multipleSelectionAll, this.multipleSelection, this.tableData.data, function (e) {
        _this4.multipleSelectionAll = e;
      });
      this.tableFrom.page = page;
      this.getList();
    },
    handleSizeChange: function handleSizeChange(val) {
      var _this5 = this;
      this.$selfUtil.changePageCoreRecordData(this.multipleSelectionAll, this.multipleSelection, this.tableData.data, function (e) {
        _this5.multipleSelectionAll = e;
      });
      this.tableFrom.limit = val;
      this.getList();
    },
    // 发送
    sendGrant: function sendGrant(id) {
      var _this6 = this;
      this.$modalSure('发送优惠劵吗').then(function () {
        (0, _marketing.couponUserApi)({
          couponId: id,
          uid: _this6.userIds
        }).then(function () {
          _this6.$message.success('发送成功');
          _this6.getList();
        });
      });
    }
  }
};